import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button, CircularProgress, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";

const PendingSignOnTable = () => {
  const [pendingData, setPendingData] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  const fetchPendingSignOns = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseURL}/api/getAllPendingSignOn`);
      setPendingData(res.data.pendingDetails || []);
      // console.log("res.data.pendingDetails", res.data.pendingDetails)
    } catch (error) {
      console.error("Error fetching pending sign-ons:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingSignOns();
  }, []);

  // Export to Excel
  // Export to Excel
  const handleExportExcel = () => {
    if (!pendingData.length) return;

    const formattedData = pendingData.map((item, index) => ({
      SNo: index + 1,
      VesselOwner: item?.vesselOwner?.company_name || "",
      VesselName: item?.ShipDetails?.vesselname || "",
      CrewingAgent: item?.crewingAgentName || "",
      CrewName: item?.crew?.name || "",
      CrewEmail: item?.crew?.email || "",
      CrewIndosNo: item?.crew?.indosno || ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PendingSignOns");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `PendingSignOns_${Date.now()}.xlsx`);
  };


  if (loading) return <CircularProgress />;

  return (
    <div>
      <Navbar />

      <Button
        variant="contained"
        color="primary"
        onClick={handleExportExcel}
        style={{ margin: "20px 0" }}
      >
        Export SignOn Details
      </Button>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Vessel Owner</TableCell>
              <TableCell>Vessel</TableCell>
              <TableCell>Crewing Agent</TableCell>
              <TableCell>Crew Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Indos No</TableCell>


            </TableRow>
          </TableHead>
          <TableBody>
            {pendingData.map((item, index) => (
              <TableRow key={item._id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item?.vesselOwner?.company_name}</TableCell>
                <TableCell>{item?.ShipDetails?.vesselname}</TableCell>
                <TableCell>{item?.crewingAgentName}</TableCell>
                <TableCell>{item.crew?.name}</TableCell>
                <TableCell>{item.crew?.email}</TableCell>
                <TableCell>{item.crew?.indosno}</TableCell>


              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PendingSignOnTable;
